/**
 * Single source of truth for outbound links and copy-level constants.
 * Values come from .env.local at build time (see .env.example).
 */
export const siteConfig = {
  name: 'VoxDiscover',
  domain: 'voxdiscover.com',
  url: import.meta.env.VITE_SITE_URL ?? 'https://voxdiscover.com',
  portalUrl: import.meta.env.VITE_PORTAL_URL ?? 'https://portal.voxdiscover.com',
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL ?? 'max@voxdiscover.com',
  /** Booking page for demo CTAs; unset falls back to a mailto request. */
  demoUrl: import.meta.env.VITE_DEMO_URL,
  /** Where prospect briefs and audio are served from (static folder or a public bucket). */
  prospectBaseUrl: import.meta.env.VITE_PROSPECT_BASE_URL ?? '/prospects',
  tagline: 'AI voice interviews that turn customers into intelligence',
} as const

export const navLinks = [
  { label: 'How it works', href: '#how-it-works' },
  { label: 'Features', href: '#features' },
  { label: 'Use cases', href: '#use-cases' },
  { label: 'FAQ', href: '#faq' },
] as const

/**
 * Trust bar under the hero (landing and prospect pages). Owner-supplied facts (2026-10-07):
 * keep them literally true. The interview count is meant to go live later (counted from the
 * portal); until then it stays a deliberately round "thousands".
 */
export const trustSignals = [
  { icon: 'research', lead: '20+ years', rest: 'of customer research' },
  { icon: 'interviews', lead: 'Thousands', rest: 'of AI interviews run' },
  { icon: 'global', lead: 'Trusted', rest: 'by teams worldwide' },
  { icon: 'privacy', lead: 'GDPR', rest: 'Hosted in the EU' },
  { icon: 'setup', lead: 'Live', rest: 'in a few clicks' },
] as const
